// ═══════════════════════════════════════════════════════════
// usePortalRealtimeEvents — realtime refresh for public portal
//
// Same poll/KV mechanism as the staff hook, but doesn't touch
// any store. Just dispatches foia:datachange so portal pages
// can re-fetch their own local state when something changed.
// ═══════════════════════════════════════════════════════════

import { useEffect, useRef } from 'react';

const POLL_MS = 5_000;

export function usePortalRealtimeEvents() {
  const lastRef = useRef(new Date(Date.now() - 10_000).toISOString());

  useEffect(() => {
    const poll = async () => {
      try {
        const since = lastRef.current;
        lastRef.current = new Date().toISOString();

        const res = await fetch(`/api/events/poll?since=${encodeURIComponent(since)}`);
        if (!res.ok) return;
        const { changed } = (await res.json()) as { changed: string[] };
        if (changed.length === 0) return;

        window.dispatchEvent(new CustomEvent('foia:datachange', {
          detail: { tables: changed },
        }));
      } catch {
        // network error — silent
      }
    };

    const id = setInterval(poll, POLL_MS);
    return () => clearInterval(id);
  }, []);
}
